/**
 * Variant of notification.
 */
export enum NotificationVariant {
  SUCCESS = 'success',
  WARNING = 'warning',
  ERROR = 'error',
  INFO = 'info',
}

/**
 * Notification properties.
 */
export interface NotificationProps {
  /**
   * Message to show.
   */
  message: string;

  /**
   * Is open flag.
   */
  open: boolean;

  /**
   * Variant of notification.
   */
  variant: NotificationVariant;

  /**
   * OnClose handler.
   */
  onClose: () => void;
}

/**
 * Notification definition.
 */
export interface Notification {
  message: string;
  variant: NotificationVariant;
  open: boolean;
}

export interface NotificationContextType {
  showNotification: (
    message: string,
    variant: NotificationVariant,
    timeout?: number
  ) => void;
  closeNotification: () => void;
}
